


















import { Vue, Component } from "vue-property-decorator";
import EducationProtocolForm from "@/components/education/EducationProtocolForm.vue";
import CBreadCrumbs from "@/components/form/CustomPage/CBreadCrumbs.vue";

@Component({ components: { CBreadCrumbs, EducationProtocolForm } })
export default class EducationProtocolNew extends Vue {
  get breadcrumbs() {
    return [
      {
        to: { name: "educationProtocolList" },
        label: `${this.$tc(this.$translate.TrainingProtocols)}`
      },
      {
        label: this.$tc(this.$translate.Create)
      }
    ];
  }
}
